export default "__VITE_ASSET__WXODI9wk__"